@import '~style-sheet-helpers/core.less';
@import '../../../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../../../../constants/spacing.module.less';

.centered {
  text-align: center;
}

.sales-email-button {
  font-size: 12px;
}

.wrapper {
  padding: @space-0 @space-0 @space-24;
  grid-column: 1 / -1;
}
